// Vendors
import { useEffect, useState } from 'react';
// Contexts
import { useAppContextConsumerHook } from 'contexts/app.context';
import { useAppInformationContextConsumerHook } from 'contexts/app-information.context';
// Constants
import {
  INTENTIONAL_NAVIGATION,
  INTENTIONAL_NAVIGATION_OFF,
} from '../constants/header-layout.constants';
// Event Handlers
import { HeaderLayoutHandlers } from '../handlers/header-layout.handlers';
import { HeaderLayoutTrackingHandlers } from '../handlers/header-layout.tracking.handlers';
// Hooks
import { useAppTrackingHook } from 'tracking/app-tracking.hook';
// Types
import { HeaderLayoutHookType } from './types/header-layout.hook.type';
// Utilities
import { allNeedDataIsLoaded } from 'providers/app-information/utils/app-information.utils';

const useHeaderLayoutHook = (): HeaderLayoutHookType => {
  const [showDropModal, setShowDropModal] = useState<boolean>(false);

  const { onBackHeader, statesVisited, setOnBackHeader, setOnBackClickHeader, onBackClickHeader } =
    useAppContextConsumerHook();

  const { informationFlags } = useAppInformationContextConsumerHook();

  const { handleTrackClickBack } = useAppTrackingHook(HeaderLayoutTrackingHandlers);

  const handlers = HeaderLayoutHandlers({
    handleTrackClickBack,
    onBackHeader,
    statesVisited,
    setOnBackHeader,
    setOnBackClickHeader,
    setShowDropModal,
    onBackClickHeader,
  });

  useEffect(() => {
    localStorage.setItem(INTENTIONAL_NAVIGATION, INTENTIONAL_NAVIGATION_OFF);
    window.addEventListener('beforeunload', handlers.handleBeforeUnload);
    window.addEventListener('popstate', handlers.handlePopState);

    return () => {
      window.removeEventListener('beforeunload', handlers.handleBeforeUnload);
      window.removeEventListener('popstate', handlers.handlePopState);
    };
  }, []);

  return {
    ...handlers,
    showDropModal,
    disableBack: !allNeedDataIsLoaded(informationFlags),
  };
};

export { useHeaderLayoutHook };
